import React from 'react'

const Page400 = (props) => {
    return (
        <div className="d-flex justify-content-center align-items-center" id="main">
            <h1 className="mr-3 pr-3 align-top border-right inline-block align-content-center">Bad Request</h1>
            <div className="inline-block align-middle">
                <h2 className="font-weight-normal lead" id="desc">{props.message}</h2>
            </div>
        </div>
    )
}

export default Page400